/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShiftManagerGroupType = {
  type: 'Enum',
} as const;
